import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';

const hasAuthToken = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hasTokenLikeValue = (value) => {
    if (!value) return false;
    const normalized = String(value).trim().toLowerCase();
    return normalized !== 'null' && normalized !== 'undefined' && normalized !== '';
  };

  const localStorageTokenKeys = ['token', 'access_token', 'refresh_token'];
  const hasKnownLocalStorageToken = localStorageTokenKeys.some((key) =>
    hasTokenLikeValue(window.localStorage.getItem(key))
  );

  const storedSession = window.localStorage.getItem('session');
  let hasSessionToken = false;
  if (hasTokenLikeValue(storedSession)) {
    try {
      const parsedSession = JSON.parse(storedSession);
      hasSessionToken = hasTokenLikeValue(parsedSession?.access_token);
    } catch (_error) {
      hasSessionToken = false;
    }
  }

  const hasCookieToken = document.cookie.split(';').some((cookie) => {
    const [rawName, ...rawValueParts] = cookie.split('=');
    const name = (rawName || '').trim().toLowerCase();
    const value = rawValueParts.join('=').trim();

    if (!hasTokenLikeValue(value)) return false;
    return (
      name.includes('token') ||
      name.includes('auth') ||
      name.includes('session') ||
      name.startsWith('sb-')
    );
  });

  return hasKnownLocalStorageToken || hasSessionToken || hasCookieToken;
};

const NotAuthorized = () => {
  const homeRoute = hasAuthToken() ? '/application-dashboard' : '/login';

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-[#0D0D0E] overflow-hidden">
      {/* Grid overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(59,130,246,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.03)_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none" />

      {/* Radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_600px_at_50%_40%,rgba(59,130,246,0.06),transparent)] pointer-events-none" />

      {/* Card */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 py-16 max-w-md w-full mx-4 bg-[#101012] border border-[#232325] rounded-2xl shadow-2xl">
        {/* Icon */}
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-500/10 border border-red-500/30 mb-6">
          <ShieldX className="w-10 h-10 text-red-400" />
        </div>

        {/* Heading */}
        <h1 className="text-white text-3xl font-bold mb-3 tracking-tight">
          403 — Not Authorized
        </h1>

        {/* Subtitle */}
        <p className="text-gray-400 text-base leading-relaxed mb-8">
          You don't have permission to view this page. Please contact your administrator if you believe this is a mistake.
        </p>

        {/* CTA */}
        <Link
          to={homeRoute}
          className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-150"
        >
          Go back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotAuthorized;
